import React from 'react';
import { MultiSelectDropdown } from '@/components/ui/MultiSelectDropdown';

interface MultiSelectFilterProps {
  label: string;
  options: string[];
  selectedValues: string[];
  placeholder: string;
  searchPlaceholder: string;
  onChange: (values: string[]) => void;
  onReset: () => void;
  hideLabel?: boolean;
}

export const MultiSelectFilter: React.FC<MultiSelectFilterProps> = ({
  label,
  options,
  selectedValues,
  placeholder,
  searchPlaceholder,
  onChange,
  onReset,
  hideLabel = false,
}) => {
  const hasValue = selectedValues.length > 0;
  return (
    <div>
      {!hideLabel && (
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-sm font-medium text-gray-700">{label}</h3>
          {hasValue && (
            <button
              onClick={onReset}
              className="text-xs text-blue-600 hover:text-blue-800 font-medium"
            >
              Reset
            </button>
          )}
        </div>
      )}
      <MultiSelectDropdown
        options={options}
        selectedValues={selectedValues}
        onChange={onChange}
        placeholder={placeholder}
        searchPlaceholder={searchPlaceholder}
        pinSelectedToTop={true}
        showClearAll={false}
      />
    </div>
  );
};

